import { SEO } from "@/components/SEO";
import { FadeIn } from "@/components/FadeIn";

export default function Privacy() {
  return (
    <div data-testid="privacy-page" className="pt-40 pb-28">
      <SEO title="Privacy Policy" description="DULORME LABS Privacy Policy." path="/privacy-policy" />
      <div className="container-custom max-w-2xl">
        <FadeIn>
          <h1 className="font-display text-4xl font-bold text-white mb-10">Privacy Policy</h1>
          <div className="space-y-8 text-sm text-zinc-400 leading-relaxed">
            <p>Last updated: This policy describes how DULORME LABS™ ("we", "us") collects, uses and protects information submitted through this website.</p>
            <div>
              <h2 className="font-display text-lg text-white mb-2">Information We Collect</h2>
              <p>We collect information you voluntarily submit through our contact and strategy call forms, including name, company, contact details and business information.</p>
            </div>
            <div>
              <h2 className="font-display text-lg text-white mb-2">How We Use Information</h2>
              <p>Information is used to respond to inquiries, evaluate potential engagements and, where enabled, for analytics and communication purposes.</p>
            </div>
            <div>
              <h2 className="font-display text-lg text-white mb-2">Third-Party Services</h2>
              <p>This site may use analytics, advertising pixels and scheduling tools (such as our booking calendar). These providers may process data under their own privacy policies.</p>
            </div>
            <div>
              <h2 className="font-display text-lg text-white mb-2">Data Retention & Requests</h2>
              <p>We retain submitted information as needed to respond to your inquiry. Contact us to request access to or deletion of your information.</p>
            </div>
            <div>
              <h2 className="font-display text-lg text-white mb-2">Contact</h2>
              <p>For privacy questions, reach out through our Contact page.</p>
            </div>
            <p className="text-zinc-600">This is a placeholder policy. Replace with a jurisdiction-specific policy reviewed by legal counsel before launch.</p>
          </div>
        </FadeIn>
      </div>
    </div>
  );
}
